import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=5df33f7d&scoped=true&"
var script = {}
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=5df33f7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df33f7d",
  null
  
)

export default component.exports